// removed by extract-text-webpack-plugin
module.exports = {"Loader":"Spinner__Loader__1DDwY","load2":"Spinner__load2__1N7mg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Spinner/Spinner.css
// module id = 157
// module chunks = 0